import { render, staticRenderFns } from "./settingPay.vue?vue&type=template&id=3362e500&scoped=true"
import script from "./settingPay.vue?vue&type=script&lang=js"
export * from "./settingPay.vue?vue&type=script&lang=js"
import style0 from "./settingPay.vue?vue&type=style&index=0&id=3362e500&prod&lang=less&scoped=true"
import style1 from "./settingPay.vue?vue&type=style&index=1&id=3362e500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362e500",
  null
  
)

export default component.exports